import { render, staticRenderFns } from "./taskLedgerDetail.vue?vue&type=template&id=626f35bc&scoped=true&"
import script from "./taskLedgerDetail.vue?vue&type=script&lang=js&"
export * from "./taskLedgerDetail.vue?vue&type=script&lang=js&"
import style0 from "./taskLedgerDetail.vue?vue&type=style&index=0&id=626f35bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626f35bc",
  null
  
)

export default component.exports